import {
  icon,
  title,
  content,
  start,
  stop
} from '../field-objects/adminMessageFields'

export const editMessageForm = { icon, title, content, start, stop }
